import React, { useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import BrandLogo from '../../components/BrandLogo';
import '../styles/admin.css';

const NAV_ITEMS = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/products', label: 'Products' },
  { to: '/admin/orders', label: 'Orders' },
  { to: '/admin/categories', label: 'Sports and Brands' },
  { to: '/admin/customers', label: 'Customers' },
  { to: '/admin/discounts', label: 'Discounts' },
  { to: '/admin/analytics', label: 'Analytics' },
  { to: '/admin/settings', label: 'Settings' },
];

function AdminLayout() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    navigate('/admin/login');
  };

  return (
    <div className="admin-app">
      <div className="admin-shell">
        {sidebarOpen && (
          <button
            type="button"
            className="admin-sidebar-overlay"
            aria-label="Close menu"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <aside className={`admin-sidebar${sidebarOpen ? ' open' : ''}`}>
          <Link to="/admin" className="admin-brand" onClick={() => setSidebarOpen(false)} aria-label="Laurenti Apparel admin">
            <BrandLogo />
          </Link>
          <div className="admin-brand-sub">Admin</div>

          <nav className="admin-nav" aria-label="Admin">
            {NAV_ITEMS.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                end={Boolean(item.end)}
                className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
                onClick={() => setSidebarOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="admin-sidebar-footer">
            <div style={{ fontSize: 13, color: '#777', padding: '0 12px 12px' }}>
              {user?.email}
            </div>
            <button
              type="button"
              className="admin-btn admin-btn-secondary"
              onClick={handleSignOut}
              style={{ width: '100%' }}
            >
              Sign out
            </button>
            <Link
              to="/"
              className="admin-btn admin-btn-ghost"
              style={{ width: '100%', marginTop: 8 }}
              onClick={() => setSidebarOpen(false)}
            >
              View storefront
            </Link>
          </div>
        </aside>

        <div className="admin-main">
          <div className="admin-topbar">
            <button
              type="button"
              className="admin-mobile-toggle"
              onClick={() => setSidebarOpen(true)}
            >
              Menu
            </button>
            <div style={{ flex: 1 }} />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
